module.exports = __webpack_public_path__ + "static/media/logo.9c213e21.png";